<template>
  <div class="container" style="margin-top:150px;">
    <div class="row">
      <div class="col-md-4 order-md-2 mb-4">
        <div class="col bg-white p-4 light-shadow wbx">
          <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
            <a class="p-4 nav-link" id="v-pills-myaccount-tab" :class="{'active': tab == 'profile'}" data-toggle="pill" @click="tab='profile'" role="tab" aria-controls="v-pills-myaccount" aria-selected="true">My Account</a>
            <a class="p-4 nav-link" id="v-pills-change-tab" :class="{'active': tab == 'reset_password'}" data-toggle="pill" @click="tab='reset_password'" role="tab" aria-controls="v-pills-change" aria-selected="false">Change Password</a>
            <a class="p-4 nav-link" href="/recruit/post-job" id="v-pills-change-tab" data-toggle="pill" role="tab" aria-controls="v-pills-change" aria-selected="false">Post job</a>
            <a class="p-4 nav-link" href="/recruit/post-private-job" id="v-pills-change-tab" data-toggle="pill" role="tab" aria-controls="v-pills-change" aria-selected="false">Post private job</a>
          </div>
        </div>
      </div>
      <div class="col-md-8 order-md-1">
        <div class="col bg-white mb-5 p-4 light-shadow wbx">
          <div class="tab-content" id="pills-tabContent">
            <div class="p-5 tab-pane fade" :class="{'active show': tab == 'profile'}" id="v-pills-myaccount" role="tabpanel" aria-labelledby="v-pills-myaccount-tab">
              <h1 class="text-primary text-center" style="font-size:1.75rem !important;">My Account</h1>
              <div class="p-4 d-flex justify-content-center">
                <img :src="$S3_url+'/Assets/images/pro.png'" class="rounded-circle" style="width:150px;height:150px" />
              </div>
              <div><a href="" v-on:click.prevent="edit=!edit">Edit profile</a></div>
              <div v-if="employer" class="mt-15">
                <div class="row form-group">
                  <div class="col-lg-4">
                    <label>Company name</label>
                  </div>
                  <div class="col-lg-8">
                    <label>: {{employer.client_name}}</label>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-lg-4">
                    <label>Official Email Id</label>
                    <!-- <input class="form-control fields" type="" name="" placeholder="Enter Official Email Id" required="required"> -->
                  </div>
                  <div class="col-lg-8">: {{employer.client_users.email}}</div>
                </div>
                <div class="row form-group">
                  <div class="col-lg-4">
                    <label>Contact Person Name</label>
                  </div>
                  <div class="col-lg-8" v-if="!edit">: {{employer.client_users.contact_person_name}}</div>
                  <div class="col-lg-8" v-if="edit">
                    <v-text-field type="text" v-model="toEdit.contact_person_name" name="C_Name"  @input="validate.checkIfEmpty(toEdit.contact_person_name, 'cp_name', 'Enter contact person name')" outlined></v-text-field>
                    <div class="error-feedback" v-if="(typeof validate.response.cp_name != 'undefined' && !validate.response.cp_name.val)" >
                      {{ validate.response.cp_name.msg }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-lg-4">
                    <label>Mobile</label>
                    <!-- <input class="form-control fields" type="" name="" placeholder="Enter Official Email Id" required="required"> -->
                  </div>
                  <div class="col-lg-8" v-if="!edit">: {{employer.client_users.mobile}}</div>
                  <div class="col-lg-8" v-if="edit">
                    <v-text-field type="text" @keydown.space.prevent v-model="toEdit.mobile" name="Mobile"  @input="validate.mobileValidation(toEdit.mobile, 'tel')&& resetFields()" outlined></v-text-field>
                    <div class="error-feedback" v-if="(typeof validate.response.tel != 'undefined' && !validate.response.tel.val)" >
                      {{ validate.response.tel.msg }}
                    </div>
                    <div class="error-feedback" v-if="mobile_error">{{mobile_err_msg}}</div>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-lg-4" >
                    <label for="state">City</label>
                  </div>
                  <div class="col-lg-8" v-if="emp_city&&!edit">: {{emp_city.city_name}}</div>
                  <div class="col-lg-8" v-if="edit">
                    <v-autocomplete v-model="toEdit.city_id" label="Select City" :items="states" item-text="text" item-value="id" :searchable="true" @input="validate.checkIfEmpty(toEdit.city_id, 'city', 'Select City')" clearable outlined deletable-chips> </v-autocomplete>
                    <div class="error-feedback" v-if="(typeof validate.response.city != 'undefined' && !validate.response.city.val)" >
                      {{ validate.response.city.msg }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-lg-4">
                    <label for="designation">Designation</label>
                  </div>
                  <div class="col-lg-8" v-if="!edit">: {{setAccountType(this.employer.client_type_id)}}</div>
                  <div class="col-lg-8" v-if="edit">
                    <v-autocomplete v-model="toEdit.user_type" :items="acctype.options" label="Account Type" item-value="value" item-text="text" placeholder="Account Type" @input="validate.checkIfEmpty(toEdit.user_type, 'acctype', 'Select Account Type')" clearable outlined></v-autocomplete>
                    <div class="error-feedback" v-if="(typeof validate.response.acctype != 'undefined' && !validate.response.acctype.val)" >
                      {{ validate.response.acctype.msg }}
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-lg-4">
                    <label>Website</label>
                  </div>
                  <div class="col-lg-8" v-if="!edit">: {{employer.website}}</div>
                  <div class="col-lg-8" v-if="edit">
                    <v-text-field type="text" v-model="toEdit.website" name="website"  outlined></v-text-field>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-lg-4">
                    <label>LinkedIn</label>
                  </div>
                  <div class="col-lg-8" v-if="!edit">: {{employer.linkedin_id}}</div>
                  <div class="col-lg-8" v-if="edit">
                    <v-text-field type="text" v-model="toEdit.linkedin_id" name="linkedin_id"  outlined></v-text-field>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-lg-4">
                    <label>Company Logo <span style="font-size:0.75rem">(recommended size: width - 150px, height - 67px)</span></label>
                  </div>
                  <div class="col-lg-8" v-if="!edit">: 
                    <img :src="$$S3_bucket_url+employer.profile_image_path" style="height:150px;margin-top:10px;border:solid 1px #c8c8c8;" v-if="employer.profile_image_path">
                  </div>
                  <div class="col-lg-8" v-if="edit">
                    <b-form-file v-model="profile_image" @input="uploadLogo()" :disabled="isUploading"></b-form-file>
                    <img :src="$$S3_bucket_url+employer.profile_image_path" v-if="employer.profile_image_path" style="height:50px;margin-top:10px;border:solid 1px #c8c8c8;">
                    <!-- <v-text-field type="text" v-model="profile_image_path" name="profile_image_path"  outlined></v-text-field> -->
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col">
                    <label><strong>About Company</strong></label>
                  </div>
                  <div class="col-lg-12" v-if="!edit" v-html="employer.description"></div>
                  <div class="col-lg-12" v-if="edit">
                    <vue-editor v-model="toEdit.description" class="editor"></vue-editor>

                    <!-- <v-text-field type="text" v-model="toEdit.description" name="description"  outlined></v-text-field> -->
                  </div>
                </div>
                <div class="row form-group mb-0">
                  <div class="col-lg-12 mt-2">
                    <label class="text-secondary"><strong>Receive alerts &amp; notifications from Hireclap</strong></label>
                    <div class="row mt-4">
                      <div class="col-xs-4 ml-4 mr-3">
                        <label for="disable" style="padding-top:5px;">Disable</label>
                      </div>
                      <div class="col-xs-4 mr-3">
                        <v-switch class="mt-0" v-model="employer.client_users.alert_enabled" @change="updateNotification"></v-switch>
                      </div>
                      <div class="col-xs-4">
                        <label for="enable" style="padding-top:5px;">Enable</label>
                      </div>
                    </div>
                  </div>  
                </div>
                <div class="row float-right mt-0" v-if="edit">
                  <div class="col-lg-12">
                    <button class="btn btn-outline-primary" @click="submitEditProfile" :disabled="isUploading">Update</button>
                  </div>
                </div>
                <div class="row">
                  <p v-if="error">{{err_msg}}</p>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" :class="{'active show': tab == 'reset_password'}" id="v-pills-change" role="tabpanel" aria-labelledby="v-pills-change-tab">
              <h2 class="text-primary text-center" style="font-size:1.75rem !important;">Change Password</h2>
              <div class="p-5 text-secondary">
                <div class="row">
                  <div class="col-lg-12">
                    <label>Current Password</label>
                    <div class="input-group mb-2 mr-sm-2">
                      <input :type="!show_current? 'password':'text'" v-model="reset.current_pass" class="form-control fields" name="current_password" placeholder="Current Password" style="border-right: none;">
                      <div class="input-group-prepend">
                        <div class="input-group-text pwd"><i toggle="#password-field" class="mdi menu-icon toggle-password" :class="{'mdi-eye-off': !show_current, 'mdi-eye': show_current}" @click="show_current= !show_current"></i></div>
                      </div> 
                    </div>
                    <div class="error-feedback" v-if="(typeof validate.response.current_password != 'undefined' && !validate.response.current_password.val) || (can_reset > 0 && !validate.response.current_password.val)" >
                      {{ validate.response.current_password.msg }}
                    </div>
                    <div class="error-feedback" v-if="can_submit >0 && current_password_error" >
                      {{ current_password_error }}
                    </div>                   
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <label>New Password</label>
                    <div class="input-group mb-2 mr-sm-2">
                      <input :type="!show_new? 'password':'text'" v-model="reset.new_pass" class="form-control fields" name="new_password" placeholder="New Password" style="border-right: none;">
                      <div class="input-group-prepend">
                        <div class="input-group-text pwd">
                          <i toggle="#password-field" class="mdi menu-icon toggle-password" :class="{'mdi-eye-off': !show_new, 'mdi-eye': show_new}" @click="show_new= !show_new"></i>
                        </div>
                      </div>
                    </div>
                    <div class="error-feedback" v-if="(typeof validate.response.new_password != 'undefined' && !validate.response.new_password.val) || (can_reset > 0 && !validate.response.new_password.val)" >
                      {{ validate.response.new_password.msg }}
                    </div> 
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <label>Confirm Password</label>
                    <div class="input-group mb-2 mr-sm-2">
                      <input :type="!show_confirm? 'password':'text'" v-model="reset.confirm_pass" class="form-control fields" name="confirm_password" placeholder="Confirm Password" style="border-right: none;">
                      <div class="input-group-prepend">
                        <div class="input-group-text pwd">
                          <i toggle="#password-field" class="mdi menu-icon toggle-password" :class="{'mdi-eye-off': !show_confirm, 'mdi-eye': show_confirm}" @click="show_confirm= !show_confirm"></i>
                        </div>
                      </div>
                    </div>
                    <div class="error-feedback" v-if="(typeof validate.response.confirm_password != 'undefined' && !validate.response.confirm_password.val) || (can_reset > 0 && !validate.response.confirm_password.val)" >
                      {{ validate.response.confirm_password.msg }}
                    </div>
                    <div class="error-feedback" v-if="can_submit >0 && confirm_password_error" >
                      {{ confirm_password_error }}
                    </div>  
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <button class="btn btn-outline-primary" @click="submitResetForm()">Change Password</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
    <b-modal id="reset-success" ref="reset-success" size="sm" title=" " body-bg-variant="primary" bod body-text-variant="light" hide-footer hide-header hide-backdrop centered>
      <div class="container text-center">Password changed</div>
    </b-modal>
    <b-modal id="update-success" ref="update-success" size="sm" title=" " body-bg-variant="primary" bod body-text-variant="light" hide-footer hide-header hide-backdrop centered>
      <div class="container text-center">Profile updated</div>
    </b-modal>
  </div>
</template>

<script>
import { VueEditor} from "vue2-editor/dist/vue2-editor.core.js";
import AwsUpload from "../../utils/s3upload"

export default({
  name: 'employer_profile',
  components: {
      VueEditor
  },
  beforeMount(){
    this.emp_data = this.$cookies.get("hire-employer").token;
    if(this.emp_data){
      new this.$apiAction().getEmployer(this.emp_data).then(res => { 
        if(res){
          this.employer= res.data; 
          this.setEmployer();
          this.getCities();
          this.getStates();
        }
      }).catch((err) => {
          this.$cookies.remove("hire-employer");
          if (err) {
            this.$router.replace("/recruit").catch(() => {});
          }
        });
    }
  },
  data(){
    return{
      validate: new this.$valid(),
      employer:null,
      emp_city:null,
      emp_data:null,
      tab:'profile',
      reset:{
        current_pass:null,
        new_pass:null,
        confirm_pass:null,
      },
      show_current:false,
      show_new:false,
      show_confirm:false,
      can_reset:0,
      current_password_error: null,
      confirm_password_error:null,
      can_submit : 0,
      edit:false,
      acctype: {
        options: [
          { value: 1, text: "Employer" },
          { value: 2, text: "Consultant" },
          { value: 3, text: "Individual" },
          { value: 4, text: "Institute" },
        ],
      },
      toEdit:{
        contact_person_name:null,
        email:null,
        mobile:null,
        user_type:null,
        city_id:null,
        website: null,
        description: null,
        linkedin_id:  null,
        profile_image_path: null
      },
      profile_image: null,
      states:[],
      email_error:false,
      mobile_error:false,
      email_err_msg:'',
      mobile_err_msg:'',
      isUploading: false,
      error:false,
      err_msg:''
    }
  },
  methods:{
    openModal: function (type = "") {
      this.open = (type == "")? this.open : type;
      if (this.open == "success") {
        this.$refs["reset-success"].show();
      }
      if(this.open == "profile-update"){
        this.$refs["update-success"].show();
      }
    },
    getCities(){
      new this.$apiAction().getStates().then((data) => {
        data.states.forEach(state => {
          state.cities.forEach(city => {
            if(city.city_id == this.employer.client_users.city_id){
              this.emp_city = city;
            }
          });
        });
      });
    },
    setAccountType(id){
      let value = null;
      this.acctype.options.forEach(opt => {
        if(opt.value === id){
          value = opt.text;
        }
      });
      return value;
    },
     updateNotification: function () {
      let token = this.$cookies.get("hire-employer").token;
      let status = this.employer.alert_enabled  ? 1 : 0;
      new this.$apiAction().updateAlertSettings(status, token).then((res) => {
          if(res.status) {
            this.success_msg = res.message
          }
          }).catch((err) => {
          if(err){
            console.log(err);
          }
        });
    },
    uploadLogo: async function() {
      const file = this.profile_image;
      this.isUploading = true;
      const awsUploader = new AwsUpload();
      try {
        var extension = this.profile_image.name.split('.')[this.profile_image.name.split('.').length-1]
        var d = new Date();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var current_date =d.getFullYear() +"/" +(month < 10 ? "0" : "") +month +"/" +(day < 10 ? "0" : "") +day;
        var timestamp = Math.floor(Date.now() / 1000);
        var filename = 'company_logo/'+ current_date+"/"+timestamp + "."+extension;
        const response = await awsUploader.uploadImage(file, filename);
        this.toEdit.profile_image_path = response.url;
      } catch (error) {
        this.error = true;
        this.err_msg = 'Something went wrong.Please retry after sometime.'
      }
      this.isUploading = false;
    },
    getStates: async function () {
      await new this.$apiAction().getStates().then(async (data) => {
        this.states.push({header: 'Top Metropolitan Cities'})
        await data.states.forEach(async (element) => {
          await element.cities.forEach(city => {
            if(city.top_city == 1){
              this.states.push({text:city.city_name,id:city.city_id, s_id:city.state_id,group:'Top Metropolitan Cities'})
            }
          });
          this.states.push({divider:true})
          this.states.push({header: element.state_name});
          element.cities.forEach(city => {
            if(city.top_city == 0){
              this.states.push({text:city.city_name,id:city.city_id, s_id:city.state_id,group:element.state_name})
            }
          });
        });
      });
    },
    setEmployer(){
      this.toEdit.contact_person_name = (this.employer.client_users?.contact_person_name)?this.employer.client_users?.contact_person_name:null;
      this.toEdit.city_id = (this.employer.client_users?.city_id)?this.employer.client_users?.city_id:null;
      this.toEdit.email = (this.employer.client_users?.email)?this.employer.client_users?.email:null;
      this.toEdit.mobile = (this.employer.client_users?.mobile)?this.employer.client_users?.mobile:null;
      this.toEdit.user_type = (this.employer.client_type_id)?this.employer.client_type_id:null;
      this.toEdit.description = (this.employer.description)?this.employer.description:null;
      this.toEdit.website = (this.employer.website)?this.employer.website:null;
    },
    resetFields(){
      this.email_error = false;
      this.mobile_error = false;
      this.email_err_msg = '';
      this.mobile_err_msg = '';
    },
    submitEditProfile(e){
      e.preventDefault();
      this.canEdit = 0;
      if(this.validate.checkIfEmpty(this.toEdit.contact_person_name, 'cp_name', 'Enter contact person name')?.val === false){
        this.canEdit++;
      }
      if(this.validate.mobileValidation(this.toEdit.mobile, "tel")?.val === false){
        this.canEdit++;
      }
      if(this.validate.emailValidation(this.toEdit.email, "email")?.val === false){
        this.canEdit++;
      }
      if(this.validate.checkIfEmpty(this.toEdit.city_id, "city", 'Select city')?.val === false){
        this.canEdit++;
      }
      if(this.validate.checkIfEmpty(this.toEdit.user_type, "acctype", 'Select designation')?.val === false){
        this.canEdit++;
      }
      if(this.canEdit == 0){
        var canUpdate = 0;
        var toUpdate = {};
        if(this.toEdit.contact_person_name != this.employer.client_users?.contact_person_name){
          toUpdate.contact_person_name = this.toEdit.contact_person_name;
          canUpdate++;
        }
        if(this.toEdit.mobile != this.employer.client_users?.mobile){
          toUpdate.mobile = this.toEdit.mobile;
          canUpdate++;
        }
        if(this.toEdit.email != this.employer.client_users?.email){
          toUpdate.email = this.toEdit.email;
          canUpdate++;
        }
        if(this.toEdit.city_id != this.employer.client_users?.city_id){
          toUpdate.city_id = this.toEdit.city_id;
          canUpdate++;
        }
        if(this.toEdit.user_type != this.employer.client_type_id){
          toUpdate.user_type = this.toEdit.user_type;
          canUpdate++;
        }
        if(this.toEdit.website != this.employer.client_users?.website){
          toUpdate.website = this.toEdit.website;
          canUpdate++;
        }
        if(this.toEdit.linkedin_id != this.employer.client_users?.linkedin_id){
          toUpdate.linkedin_id = this.toEdit.linkedin_id;
          canUpdate++;
        }
        if(this.toEdit.profile_image_path != this.employer.client_users?.profile_image_path){
          toUpdate.profile_image_path = this.toEdit.profile_image_path;
          canUpdate++;
        }
        if(this.toEdit.description != this.employer.client_users?.description){
          toUpdate.description = this.toEdit.description;
          canUpdate++;
        }
        if(canUpdate > 0){
          new this.$apiAction().editProfile(toUpdate,this.emp_data).then(res => {
            if(res.message == 'Employer profile updated'){
                this.openModal("profile-update");
                setTimeout(() => {
                  this.$refs["update-success"].hide();
                },1000)
              location.reload();
            }else if(res.message == ('Email already exists' || 'Mobile already exists')){
              this.email_error = (res.message == 'Email already exists')?true:false;
              this.email_err_msg = (this.email_error)? res.message:'',
              this.mobile_error = (res.message == 'Mobile already exists')? true:false;
              this.mobile_err_msg = (this.mobile_error)? res.message:'';
            }else{
              console.log('error');
            }
          });
        }
      }else{
        console.log('empty field',this.canEdit);
      }
    },
    submitResetForm(){
      this.can_reset = 0;
      if(this.validate.checkIfEmpty(this.reset.current_pass, "current_password", 'Enter Current Password')?.val === false){
        this.can_reset++;
      }
      if(this.validate.passwordValidation(this.reset.new_pass, "new_password")?.val === false){
        this.can_reset++;
      }
      if(this.validate.checkIfEmpty(this.reset.confirm_pass, "confirm_password", 'Enter Confirm Password')?.val === false){
        this.can_reset++;
      }

      if(this.can_reset == 0){
       new this.$apiAction().resetPassword(this.reset, this.emp_data).then(res => {
         if(res){
          this.confirm_password_error = null;
          this.current_password_error = null;
          this.can_submit = 0;

          if(res.message == 'User Password Updated'){
                this.openModal("success");
                setTimeout(() => {
                  this.$refs["reset-success"].hide();
                },1000)
              location.reload();
          }else{
            if(res.confirm_pass){
              this.can_submit++;
              this.confirm_password_error = res.confirm_pass[0]
            }
            if(res.current_pass){
              this.can_submit++;
              this.current_password_error = res.current_pass[0]
            }
          }
         }
       })
      }
    }
  }
})
</script>

<style scoped>
  @import "~vue2-editor/dist/vue2-editor.css";

  /* Import the Quill styles you want */
  @import '~quill/dist/quill.core.css';
  @import '~quill/dist/quill.bubble.css';
  @import '~quill/dist/quill.snow.css';
  .rounded-circle{
    border-radius: 50% !important;
  }
  .pwd{
    border-radius: 0px 5px 5px 0px !important;
    background: #fff;
    border-left: none;
  }
  .toggle-password{
    cursor: pointer;
  }
  .truncate-words{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  .note-editor{
      background-color: #E4E4E4 !important;
  }
  .note-btn{
      background-color: #fff !important;
      border: 1px solid #afafaf !important;
      height: 30px !important;
      margin: 0.1rem;
  }
  .note-btn:hover{
      background-color: #e9e9e9 !important;
  }
  .editor{
      background-color: #fff;
  }
</style>